import React, { useState, useMemo, useEffect } from "react";
import "./VariantSelector.css";
import { useCart } from "../../Modules/Hooks/useCart";
import { Minus, Plus, Check, ShoppingBag } from "lucide-react";
import API_BASE_URL from "../../config";
import Image from "../Image/Image";

const VariantSelector = ({ product, variants, onClose }) => {
  const [selectedVariant, setSelectedVariant] = useState(variants[0]);
  const [quantity, setQuantity] = useState(1);
  const { addToCart } = useCart();

  useEffect(() => {
    const first = variants[0];
    setSelectedVariant(first);
    setQuantity(1);
  }, [product?.product_id, variants]);

  const handleAddToCart = () => {
    if (!selectedVariant) return;
    addToCart(product, selectedVariant, quantity);
    onClose();
  };

  const totalPrice = useMemo(() => {
    if (!selectedVariant) return 0;
    return selectedVariant.price * quantity;
  }, [selectedVariant, quantity]);

  if (!variants?.length || !selectedVariant) {
    return (
      <div className="VS VS--empty">
        <p className="VS--EmptyText">
          Для этого блюда пока не настроены варианты и цена. Загляните позже
          или спросите у кафе.
        </p>
        <button type="button" className="VS--AddBtn VS--AddBtn--solo" onClick={onClose}>
          Закрыть
        </button>
      </div>
    );
  }

  return (
    <div className="VS">
      <div className="VS--Hero">
        <Image
          src={`${API_BASE_URL}${product.image_url}`}
          alt={product.product_name}
          className="VS--Image"
        />
        <div className="VS--HeroOverlay" />
      </div>

      <div className="VS--Body">
        <h3 className="VS--Title">{product.product_name}</h3>
        {product.composition && (
          <p className="VS--Desc">{product.composition}</p>
        )}

        {variants.length > 1 && (
          <div className="VS--Section">
            <span className="VS--Label">Выберите вариант</span>
            <div className="VS--Options">
              {variants.map((variant) => {
                const active =
                  selectedVariant.variant_id === variant.variant_id;
                return (
                  <button
                    type="button"
                    key={variant.variant_id}
                    className={`VS--Option ${active ? "is-active" : ""}`}
                    onClick={() => setSelectedVariant(variant)}
                  >
                    <span className="VS--OptionInfo">
                      <span className="VS--OptionSize">
                        {variant.size || "Стандарт"}
                      </span>
                      {variant.weight && (
                        <span className="VS--OptionWeight">
                          {variant.weight} г
                        </span>
                      )}
                    </span>
                    <span className="VS--OptionPrice">
                      {variant.price} ₽
                      {active && (
                        <span className="VS--OptionCheck">
                          <Check size={12} />
                        </span>
                      )}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </div>

      <div className="VS--Foot">
        <div className="VS--Qty">
          <button
            type="button"
            onClick={() => setQuantity((q) => Math.max(1, q - 1))}
            aria-label="Уменьшить количество"
            disabled={quantity <= 1}
          >
            <Minus size={16} />
          </button>
          <span>{quantity}</span>
          <button
            type="button"
            onClick={() => setQuantity((q) => q + 1)}
            aria-label="Увеличить количество"
          >
            <Plus size={16} />
          </button>
        </div>
        <button
          type="button"
          className="VS--AddBtn"
          onClick={handleAddToCart}
        >
          <ShoppingBag size={18} />
          <span>В корзину</span>
          <span className="VS--AddPrice">{totalPrice.toFixed(0)} ₽</span>
        </button>
      </div>
    </div>
  );
};

export default VariantSelector;
